import React from 'react';
import { AlertTriangle, LogOut, RefreshCw } from 'lucide-react';

export default function AutoLogoutWarning({ show, countdown, onStay, onLogout }) {
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[100]">
      <div className="bg-white dark:bg-slate-800 rounded-xl shadow-2xl p-6 max-w-md mx-4 animate-in fade-in zoom-in duration-200">
        <div className="flex items-center gap-3 mb-4">
          <div className="p-3 bg-amber-100 dark:bg-amber-900/30 rounded-full">
            <AlertTriangle className="w-6 h-6 text-amber-600 dark:text-amber-400" />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-[#0F172A] dark:text-white">
              Sesi Akan Berakhir
            </h3>
            <p className="text-sm text-slate-500 dark:text-slate-400">
              Tidak ada aktivitas terdeteksi
            </p>
          </div>
        </div>

        <div className="text-center py-6">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-red-100 dark:bg-red-900/30 mb-3">
            <span className="text-3xl font-bold text-red-600 dark:text-red-400">
              {countdown}
            </span>
          </div>
          <p className="text-slate-600 dark:text-slate-300">
            Anda akan logout otomatis dalam <strong>{countdown} detik</strong>
          </p>
        </div>

        <div className="flex gap-3">
          <button
            onClick={onLogout}
            className="flex-1 flex items-center justify-center gap-2 px-4 py-2.5 border border-slate-300 dark:border-slate-600 text-slate-700 dark:text-slate-300 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-700 transition-colors"
          >
            <LogOut size={18} />
            Logout Sekarang
          </button>
          <button
            onClick={onStay}
            className="flex-1 flex items-center justify-center gap-2 px-4 py-2.5 bg-emerald-600 text-white rounded-lg hover:bg-emerald-700 transition-colors font-medium"
          >
            <RefreshCw size={18} />
            Tetap Login
          </button>
        </div>
      </div>
    </div>
  );
}
